/**
 * The backend sends its dates as `YYYY-MM-DD HH:mm:ss` in UTC, with no timezone mark (for example
 * the `started_at` / `completed_at` of a queue status). A date string without a timezone is read
 * by the browser as LOCAL time, so a sync that finished at 13:44 UTC showed as 01:44 pm for a user
 * in Saudi Arabia (UTC+3): three hours early (PC-2417).
 *
 * Read a backend date as UTC when it carries no timezone, and leave a value that already names its
 * zone (`Z` or an offset such as `+03:00`) alone.
 */
const ZONELESS_DATETIME = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})(\.\d+)?$/;

export function parseServerDate(value: string | Date): Date {
  if (value instanceof Date) {
    return value;
  }

  const zoneless = ZONELESS_DATETIME.exec(value.trim());

  return zoneless
    ? new Date(`${zoneless[1]}T${zoneless[2]}${zoneless[3] ?? ''}Z`)
    : new Date(value);
}
